let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cuyPa")).then(() => parcelRequire('7zjHG'));